var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"certificate-page"},_vm._l((_vm.list),function(it){return _c('div',{key:it.title},[_c('div',{staticClass:"shopping-title"},[_c('h1',[_vm._v(_vm._s(it.title))]),_vm._v(" "),_c('i')]),_vm._v(" "),_c('img',{attrs:{"src":it.url,"alt":it.title}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d76d846","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/certificate/index.vue
// module id = null
// module chunks = 